"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.getSlideItemInfo = exports.getSlideInfo = exports.getSlideIndexForMultipleItems = exports.getSlideIndexForNonMultipleItems = exports.getActiveSlideDotsLength = exports.getActiveSlideIndex = void 0;
var getActiveSlideIndex = function getActiveSlideIndex(e, t) {
    var t = t || {},
      i = t.activeIndex,
      o = t.itemsInSlide,
      t = t.itemsCount,
      i = i + o;
    return 1 === o ? (0, exports.getSlideIndexForNonMultipleItems)(i, o, t) : (0, exports.getSlideIndexForMultipleItems)(i, o, t, e);
  },
  getActiveSlideDotsLength = (exports.getActiveSlideIndex = getActiveSlideIndex, function (e, t) {
    var i;
    return void 0 === t && (t = 1), (e = void 0 === e ? 0 : e) && t ? (i = Math.floor(e / t), e % t == 0 ? i - 1 : i) : 0;
  }),
  getSlideIndexForNonMultipleItems = (exports.getActiveSlideDotsLength = getActiveSlideDotsLength, function (e, t, i) {
    return e < t ? i - t : i < e ? 0 : e - 1;
  }),
  getSlideIndexForMultipleItems = (exports.getSlideIndexForNonMultipleItems = getSlideIndexForNonMultipleItems, function (e, t, i, o) {
    var l = (0, exports.getActiveSlideDotsLength)(i, t);
    return e === i + t ? 0 : o || e < t && 0 !== e ? l : 0 === e ? i % t == 0 ? l : l - 1 : 0 < t ? Math.floor(e / t) - 1 : 0;
  }),
  getSlideInfo = (exports.getSlideIndexForMultipleItems = getSlideIndexForMultipleItems, function (e, t) {
    void 0 === t && (t = 0);
    e = (e = void 0 === e ? 0 : e) + 1;
    return e < 1 ? e = t : t < e && (e = 1), {
      item: e,
      itemsCount: t
    };
  }),
  getSlideItemInfo = (exports.getSlideInfo = getSlideInfo, function (e) {
    var e = e || {},
      t = e.itemsInSlide,
      i = e.activeIndex,
      o = e.infinite,
      l = e.itemsCount;
    return e.isStageContentPartial ? {
      isPrevSlideDisabled: !0,
      isNextSlideDisabled: !0
    } : {
      isPrevSlideDisabled: !1 === o && 0 === i,
      isNextSlideDisabled: !1 === o && l - t <= i
    };
  });
exports.getSlideItemInfo = getSlideItemInfo;